import Vue from 'vue'

Vue.prototype.$userType = {
  Admin: 1,
  User: 2,
  Stockroom: 3,
  Courier: 4,
  Accountant: 5,
}
